// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2eqbi","amount":"Amount_amount__3C-Kh","tip":"Amount_tip__1TCHL","tipHeader":"Amount_tipHeader__tmi_b","tipsWrap":"Amount_tipsWrap__3Q-Q5"};